import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const GetOfficialsForEvaluationSelectionData = (otsMeetId, hasEvaluator, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      otsMeetId,
      hasEvaluator,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const otsMeetIdForUrl = otsMeetId ? encodeURIComponent(otsMeetId) : 'NaN';
    const hasEvaluatorForUrl = hasEvaluator === true || hasEvaluator === false ? encodeURIComponent(hasEvaluator) : '';
    const url = `/MeetOfficial/OtsMeet/${otsMeetIdForUrl}/Evaluation?hasEvaluator=${hasEvaluatorForUrl}`;
    PersonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetOfficialsForEvaluationSelectionData;